
import { ref } from 'vue';

export default {
  components: {},
  setup() {
    return {};
  }
};
